__turbopack_context__.v({
  "className": "instrument_sans_96571aa6-module__dULORW__className",
});
